import React from 'react';

import containerStyles from '../Instructions.scss';
import qmStyles from '../../../../../theme/qmStyles';
import QmImage from '../../../../../components/Image/QmImage';

const GenericSplash = () => (
  <>
    <h3
      className={containerStyles.titleText}
      style={{ paddingBottom: qmStyles.gutter }}
    >
      Welcome to Quartermaster!
    </h3>
    <div
      style={{
        marginLeft: qmStyles.tripleGutter,
        marginRight: qmStyles.tripleGutter,
      }}
    >
      <QmImage src="static/ui/signup/about_us.png" />
    </div>
    <p className={containerStyles.descriptionText}>
      Find and book local Pros referred by your neighbours and friends.
    </p>
  </>
);

export default GenericSplash;
